<template>
  <div class="bg-gray-10 px-4">

    <section class="mx-auto max-w-[732px]">
      <div class="flex justify-end"><Button class="mt-6 mb-6 align-" variant="primary" size="small" @click="logout">Logga ut</Button></div>
      <h1 class="text-t1 mb-6" v-html="webapp_config.msg.errorreport_oncall_heading"></h1>
    </section>
    <div class="max-w-[732px] mx-auto bg-white rounded-[15px] py-4 px-4 md:py-12 md:px-14 border border-solid border-gray-light">
      <template v-if="referenceNumber">
        <div>
          <h4 class="text-t4 mb-2">Ditt ärende är registrerat!</h4>
          <p class="mb-4">Ett ärende med ärendenummer <span class="font-thick">{{ referenceNumber }}</span> har skapats</p>
          <p class="mb-4" v-if="group == 'BEREDSK S'"><span class="font-bold">Nästa steg:</span><br />
            Kontakta Beredskap Södra<br />
            Södra: <span v-html="webapp_config.msg.oncall_phone_south"></span>
          </p>
          <p class="mb-4" v-else-if="group == 'BEREDSK N'"><span class="font-bold">Nästa steg:</span><br />
            Kontakta Beredskap Norra<br />
            Tel: <span v-html="webapp_config.msg.oncall_phone_north"></span>
          </p>
          <p class="mb-4" v-else><span class="font-bold">Nästa steg:</span><br />
            Ingen Beredskapsgrupp kunde kopplas till ärendet. Du måste kontakta båda:<br />
            Norra: <span v-html="webapp_config.msg.oncall_phone_north"></span><br />
            Södra: <span v-html="webapp_config.msg.oncall_phone_south"></span>
          </p>
          <Button variant="primary" size="large" @click="reset()">
            Skapa en till felanmälan
          </Button>
        </div>
      </template>
      <template v-else>
        <Form @submit="onSubmit" :validation-schema="schema" v-autofill-event v-slot="{ meta }">
          <div class="infotext mb-6 text-preamble" v-html="webapp_config.msg.errorreport_oncall_text"></div>

          <fieldset>
            <div>
              <h2 class="text-t6 mb-[10px]">Objekt</h2>

              <p :class="{ control: true }" style="position: relative">
                <SearchField
                  :options="options"
                  placeholder="Sök efter adress eller namn"
                  :place-button-start="true"
                  :require-enter-to-search="false"
                  @update:modelValue="handleInputChange"
                  :display-label="false"
                  ref="searchInput"
                  :autoComplete="false"
                  type="search"
                  class="search"
                  :showLoader="isFetching"
                  :value="query"
                />


                <ul v-if="displayDropdown" class="dropdown" :style="{ top: inputRefHeight}">
                  <li v-if="!isFetching && Object.keys(options).length === 0" class="dropdown-item">
                    <Button variant="text"
                            class="font-proxima-nova dark-turquoise text-wrap text-start py-4 font-normal" disabled>Inga
                      träffar
                    </Button>
                  </li>
                  <li
                    tabindex="0"
                    v-for="{id, name, objectCode} in options"
                    v-bind:key="id"
                    @focus="scrollTo"
                    class="dropdown-item"
                  >
                    <Button variant="text"
                            class="font-proxima-nova dark-turquoise text-wrap text-start py-4 font-normal"
                            @click="onChange(id, name, objectCode)">{{ name }}
                    </Button>
                  </li>
                </ul>
              </p>
            </div>

            <div>
              <p>
                <Field
                  v-slot="{ field, meta }"
                  v-model="report.rentalObjectCode"
                  name="errorReportRentalObject"
                  type="text"
                  id="report-rental-object-input"
                >
                  <input
                    :class="inputClasses"
                    v-bind="field"
                    :data-invalid="!meta.valid && meta.touched ? 'true' : 'false'"
                    placeholder="Objektsnummer"
                    autocomplete="off"
                    disabled
                  />
                </Field>
              </p>
            </div>
          </fieldset>
          <fieldset>
            <div>
              <h2 class="text-t6 mb-[10px]">Kontaktuppgifter anmälare</h2>
              <p :class="{ control: true }">
                <Field
                  v-slot="{ field, meta }"
                  v-model="report.reporteeName"
                  id="error-report-contact-person-input"
                  name="errorReportContactPerson"
                  type="text"
                >
                  <Input
                    id="reporteeName"
                    type="text"
                    :class="inputClasses"
                    v-bind="field"
                    :data-invalid="!meta.valid && meta.touched ? 'true' : 'false'"
                    label="Anmälare namn"
                    floating-label=true
                  />
                </Field>
              </p>
            </div>
            <div>
              <Field
                v-slot="{ field, meta }"
                v-model="report.reporteePhone"
                name="errorReportContactPhone"
                type="text"
                id="error-report-phone-input"
              >
                <Input
                  id="reporteePhone"
                  :class="inputClasses"
                  v-bind="field"
                  :data-invalid="!meta.valid && meta.touched ? 'true' : 'false'"
                  label="Anmälare telefon"
                  floating-label
                />
              </Field>
            </div>

          </fieldset>
          <fieldset>
            <div>
              <h2 class="text-t6 mb-[10px]">Felbeskrivning</h2>
              <p :class="{ control: true }">
                <Field
                  v-slot="{ field, meta }"
                  v-model="report.description"
                  name="errorReportDescription"
                  type="text"
                  id="error-report-description-input"
                >
                <textarea
                  id="description"
                  :class="inputClasses"
                  :style="report.description.length > 1000 ? { border: '2px solid #dc2626' } : {}"
                  :data-error="report.description.length > 1000 ? 'true' : 'false'"
                  v-bind="field"
                  :data-invalid="!meta.valid && meta.touched ? 'true' : 'false'"
                  placeholder="Beskriv felet"
                  autocomplete="off"
                  rows="4"
                />
                  <span :class="report.description.length > 1000 ? 'text-red-600' : 'text-gray-500'" class="text-sm mt-1 block text-right">
                  {{ report.description.length }}/1000
                </span>
                </Field>
              </p>
            </div>
          </fieldset>
          <fieldset>
            <div>
              <h2 class="text-t6 mb-[10px]">Larmoperatör</h2>
              <Field
                v-slot="{ field, meta }"
                v-model="report.user"
                name="errorReportUser"
                type="text"
                id="error-report-user"
              >
                <Input
                  id="user"
                  disabled
                  :class="inputClasses"
                  v-bind="field"
                  :data-invalid="!meta.valid && meta.touched ? 'true' : 'false'"
                  label="Larmoperatör"
                  floating-label
                />
              </Field>
            </div>

          </fieldset>



          <!---->
          <div class="mt-6 button-container">
            <Button type="submit" variant="primary" :loading="showLoader" :disabled="showLoader || !meta.valid " loadingText="Skickar.." size="extralarge">
              Skicka
            </Button>
          </div>
          <p class="mt-4 w-fit rounded-[4px] bg-danger-10 pb-2 pl-4 pr-4 pt-2" v-if="submitError">Något gick fel. Försök igen eller kontakta oss om problemet kvarstår.</p>
        </Form>
      </template>
    </div>
  </div>
</template>

<script setup>

const schema = {
  errorReportRentalObject: 'required|max:30',
  errorReportContactPerson: 'required|max:30',
  errorReportContactPhone: 'required|min:7|regex:^([0 +][0-9 +-]+)$|',
  errorReportDescription: 'required|max:1000',
};
</script>

<script>
import {mapActions, mapGetters} from 'vuex';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Loader from '@/components/ui/loader';
import Button from '@/components/ui/button';
import SearchField  from "../components/search/filters_new/searchfield.vue";
import Input from '@/components/ui/form/input';
import {debounce, filter} from 'lodash';
import auth from '@/auth/index';
export default {
  name: 'CommercialErrorReport',
  components: { SearchField, Loader, Button, ErrorMessage, Field, Form, Input},
  data() {
    return {
      showLoader: false,
      submitError: false,
      referenceNumber: null,
      group: '',
      report: {
        rentalObjectCode: null,
        maintenanceId: null,
        reporteeName: '',
        reporteePhone: '',
        user: '',
        description: '',
      },
      query: '',
      options: {},
      inputRef: null,
      inputRefHeight: '0px',
      displayDropdown: false,
      isFetching: false,
      inputClasses: 'bg-gray-light rounded-[6px] border-[1px] border-text-black placeholder-shown:text-gray-dark',
    };
  },
  computed: {
    ...mapGetters({ commercialPremises: 'commercialPremises', webapp_config: 'webapp_config', contracts: 'contracts' }),
    ...mapActions('oncallStore', ['getOncallItems', 'getOncallItemById']),
  },
  mounted() {
    this.inputRef = this.$refs.searchInput;
    const inputRefEl = this.inputRef?.$el;
    if (inputRefEl) {
      const inputElement = inputRefEl.querySelector('input');
      const inputMargin = parseFloat(getComputedStyle(inputElement).marginBottom) || 0;
      this.inputRefHeight = `${inputRefEl.offsetHeight - inputMargin}px`;

      inputElement.addEventListener("blur", debounce(() => {
        this.displayDropdown = false;
      }, 200));

      inputElement.addEventListener("focus", debounce(() => {
        this.displayDropdown = true;
      }, 200));
    }
  },
  methods: {
    async logout() {
      await auth.logoutOncall()
    },
    async updateOptions() {
      this.isFetching = true;
      this.options = await this.$store.cache.dispatch('getOncallItems', {query: this.query});
      this.isFetching = false;
      this.displayDropdown = true;
    },

    async onChange(id, name, objectCode) {
      this.query = name;
      this.report.rentalObjectCode = objectCode ?? name;
      this.report.maintenanceId = id;
      //await this.$store.dispatch('getOncallItemsById', evt);
      /*this.report.rentalObjectCode = premise.premiseCode;
      this.report.leaseId = premise.leaseId;
      if(!!premise.contactName) {
        this.report.contact = premise.contactName;
      }

      if(!!premise.phone) {
        this.report.phone = premise.phone
      }*/

      this.displayDropdown = false;
    },

    onSubmit() {
      this.showLoader = true;
      this.submitError = false;
      return this.$store
        .dispatch('createOncallErrorReport', (({ user, ...rest }) => rest)(this.report))
        .then((response) => {
          this.referenceNumber = response.helpdeskid;
          this.group = response.officeCode;
          window.scroll(0, 0);
        })
        .catch(() => {
          this.submitError = true;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },

    handleInputChange: debounce(async function (value) {
      this.query = value;
      await this.updateOptions()
    }, 300),
    reset() {
      this.referenceNumber = null;
      this.report = { ...this.report,
        description: '',
        reporteeName: '',
        reporteePhone: '',
        maintenanceId: '',
      };
    },
  },
  created() {
    window.scroll(0, 0);

    if(!this.$route.path.match(/^\/login-oncall/)) {
      this.showLoader = true;
      return Promise.all([
        this.$store.dispatch('checkAuthStatusOnCall'),
        this.$store.cache.dispatch('getUser'),
      ])
        .finally(() => {
          this.report.user = this.$store.getters.userEmail ?? 'E-post saknas';
          this.showLoader = false;
        });
    }




    /*this.$router.beforeEach((to, from, next) => {
      // pingar
      if (this.authStatus === true) this.$store.dispatch('ping');

      // gå till sidan
      return next();
    });*/

    // ();
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
fieldset {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 24px;
}

.input-field {
  margin-bottom: 15px;
}

#error-report-form {
  width: 100%;
  padding-bottom: 15px;
}


label {
  margin-bottom: 4px;
  display: inline-block;
  margin-top: 20px;
}

.mypages [class*=grid-] {
  padding-left: 0;
  padding-right: 0;
}


.btn-primary:disabled {
  cursor: default;
  color: $textcolorwhite;
  background-color: $gray;
}

input, textarea {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 1.6rem;
  background: #fff;
  line-height: 1.4;
  outline: none;
  transition: box-shadow .15s linear;

  &:not(:focus).is-danger {
    border-color: #D32F2F !important;
  }

  &:focus-within {
    outline: $abgblue 2px solid !important;
  }

  &:disabled {
    background-color: $lightgray;
  }

  &::placeholder {
    color: rgba(94, 94, 94, var(--tw-text-opacity, 1));
  }

  &:focus {
    box-shadow: unset !important;
    border: 1px solid $abgdarkblue !important;
  }

  &:focus[data-error="true"] {
    border: 2px solid #dc2626 !important;
  }

  &[type=checkbox] {
    width: 20px;
    height: 20px;
    box-shadow: none;
    accent-color: #007893;
  }

  &[type="radio"] {
    width: fit-content;
    display: block !important;
    accent-color: #007893;
    margin-right: 8px;

    &:checked+label {
      background: transparent !important;
    }
  }
}

[role="alert"] {
  color: #000!important;
  background-color: #FBEBEB;
  border: 1px solid #D32F2F;
  padding: 12px 16px;
  margin-top: 8px;
  display: inline-block;
  border-radius: 2px;
  font-size: 1.3rem!important;
}

label {
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.2;
}

.dropdown {
  border-radius: 10px;
  border: 1px solid #E9E9E9;
  background: #FFF;
  position: absolute;
  z-index: 10;
  width: 100%;
  max-height: 200px;
  overflow: auto;
  box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.10);
}

.dropdown-item {
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-bottom: 1px solid #E9E9E9;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="scss">
.infotext {
  h3 {
    font-size: 23px;
    margin-bottom: 10px;
    font-weight: bold;
  }
  p, ul, li {
    font-size: 1.6rem;
    line-height: 1.2;
  }

  ul {
    list-style: unset!important;
  }

  li {
    margin-bottom: 16px;
  }
}

.search div:not([class]) {
  margin: 0 !important;

  & input {
    margin: 0 !important;
    padding-top: 16px !important;
    padding-bottom: 16px !important;

    &:focus-within {
      outline: $abgblue 2px solid !important;
    }
  }

  & button.start {
    top: 50%;
    transform: translateY(-50%);
    left: 12px;
    right: unset;
  }
}
</style>
